import { Controller } from "stimulus"

export default class extends Controller {
  scrollTop() {
    window.scrollTo(0, 0);
  }
}